import { render, staticRenderFns } from "./CommandAssistant.vue?vue&type=template&id=8a6c442a&scoped=true&"
import script from "./CommandAssistant.vue?vue&type=script&lang=js&"
export * from "./CommandAssistant.vue?vue&type=script&lang=js&"
import style0 from "./CommandAssistant.vue?vue&type=style&index=0&id=8a6c442a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6c442a",
  null
  
)

export default component.exports